import React from 'react'
import { useParams } from 'react-router-dom'
import { makeStyles } from '@material-ui/core'
import FadeIn from '../../../molecules/Transitions/FadeIn'
import EmptySection from '../../../atoms/EmptySection'

const useStyles = makeStyles(() => ({
  container: { padding: '1rem' }
}))

function BatchDetail () {
  const classes = useStyles()
  const { batchId } = useParams()
  return (
    <FadeIn className={classes.container}>
      <EmptySection
        title='Batch status — coming soon'
        description={`Status view for batch ${batchId} is not implemented yet. The Workflow service has been notified.`}
      />
    </FadeIn>
  )
}

export default BatchDetail
